<ion-modal
  [isOpen]="isOpen"
  (didDismiss)="onClose()"
  [initialBreakpoint]="initialBreakpoint"
  [breakpoints]="breakpoints"
  class="modal-filter"
  [class.auto-height-sheet]="autoHeight"
  [canDismiss]="true"
  handleBehavior="none"
>
  <ng-template>
    @if (titleKey) {
    <div class="sheet-header">
      <h2 class="sheet-title">{{ titleKey | translate }}</h2>
      <button type="button" class="sheet-close" (click)="onClose()">
        <ion-icon name="close-outline" aria-hidden="true" />
        <span class="visually-hidden">{{ "dynamic-filter-modal.close" | translate }}</span>
      </button>
    </div>
    } @else {
    <div class="search-modal-header-centered" (click)="onClose()">
      <span class="close-content">
        <ion-icon name="close-outline" class="icon-inline" />
        {{ "core.close-modal" | translate }}
      </span>
    </div>
    }

    <!-- El contenido proyectado se captura una sola vez: dos <ng-content> en
         ramas distintas no proyectan bien. Con autoHeight no hay <ion-content>
         (anularía el auto-height). -->
    <ng-template #body><ng-content></ng-content></ng-template>
    @if (autoHeight) {
    <div class="container is-auto-height">
      <ng-container *ngTemplateOutlet="body" />
    </div>
    } @else {
    <ion-content class="ion-padding">
      <div class="container">
        <ng-container *ngTemplateOutlet="body" />
      </div>
    </ion-content>
    }
  </ng-template>
</ion-modal>
